var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "40",
      "height": "40",
      "fill": "#F1D5AA",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 40 40"
    }
  }, _vm.$listeners), [_c("style", {
    tag: "component"
  }, [_vm._v(".winemenu_svg__st0{fill:none;stroke:#f1d5aa;stroke-width:1.4043;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.1667}")]), _c('path', {
    staticClass: "winemenu_svg__st0",
    attrs: {
      "d": "M23.8 4.6v8.3c-.2 1.3.3 2.7 1.4 3.5 1.7 1.4 2.7 3.4 2.8 5.6v12.6c0 .8-.6 1.4-1.4 1.4h-9.8c-.8 0-1.4-.6-1.4-1.4V22.1c.1-2.2 1.1-4.2 2.8-5.6 1.1-.8 1.6-2.2 1.4-3.5V4.6"
    }
  }), _c('path', {
    staticClass: "winemenu_svg__st0",
    attrs: {
      "d": "M15.4 23.5H28v7H15.4v-7zM23.8 8h-4.2V4.5c0-.4.3-.7.7-.7h2.8c.4 0 .7.3.7.7V8z"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }